import type { App } from "@open-booking/server";
import type { BulkLengthDiscountsPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type GetTiersResponse = App["~Routes"]["properties"][":id"]["length-discounts"]["get"]["response"]["200"];
type SetTiersResponse = App["~Routes"]["properties"][":id"]["length-discounts"]["put"]["response"]["200"];

export type LengthDiscountTier = GetTiersResponse["tiers"][number];

export const propertyLengthDiscountApi = createApi({
	reducerPath: "propertyLengthDiscountApi",
	baseQuery: edenBaseQuery(),
	tagTypes: ["LengthDiscountTiers"],
	endpoints: (builder) => ({
		getLengthDiscountTiers: builder.query<GetTiersResponse, string>({
			query:
				(propertyId): EdenCall<GetTiersResponse> =>
				(client) =>
					client.properties({ id: propertyId })["length-discounts"].get(),
			providesTags: ["LengthDiscountTiers"],
		}),
		setLengthDiscountTiers: builder.mutation<SetTiersResponse, { propertyId: string; data: BulkLengthDiscountsPayload }>({
			query:
				({ propertyId, data }): EdenCall<SetTiersResponse> =>
				(client) =>
					client.properties({ id: propertyId })["length-discounts"].put(data),
			invalidatesTags: ["LengthDiscountTiers"],
		}),
	}),
});

export const { useGetLengthDiscountTiersQuery, useSetLengthDiscountTiersMutation } = propertyLengthDiscountApi;
